import React, { ReactNode } from 'react';
import UIBox from 'components/ui/UIBox';
import heroBgLeft from 'assets/bg/hero-left-part.png';
import heroBgRight from 'assets/bg/hero-right-part.png';
import UIContainer from 'components/ui/UIContainer';
import { Stack } from '@mui/material';
import UIFlex, { IUIFlexProps } from 'components/ui/UIFlex';

interface ITitleSectionProps extends Pick<IUIFlexProps, 'jc' | 'ai'> {
  children: ReactNode;
  contentCard?: boolean;
  contentCardPaddingY?: number | string;
  disableDecorators?: boolean;
  hideBreadcrumbs?: boolean;
  maxWidth?: number | string;
  minHeight?: number | string;
}

const TitleSection: React.FC<ITitleSectionProps> = ({
  children,
  jc = 'center',
  ai = 'center',
  contentCard = false,
  contentCardPaddingY = '50px',
  disableDecorators = false,
  maxWidth = 800,
  minHeight = '50vh',
}) => {
  return (
    <UIContainer>
      <Stack>
        <UIFlex
          ai={ai}
          jc={jc}
          sx={{ minHeight, flexGrow: 1, position: 'relative' }}
        >
          <UIBox
            textAlign={'center'}
            maxWidth={contentCard ? '100%' : maxWidth}
            mx={'auto'}
            position={'relative'}
            zIndex={1}
            sx={
              contentCard
                ? {
                    backgroundColor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'primary.tableBorder',
                    borderRadius: 2,
                    mb: 4,
                    mt: 3,
                    px: { xs: 2.5, md: 5 },
                    py: contentCardPaddingY,
                    width: '100%',
                  }
                : undefined
            }
          >
            {children}
          </UIBox>

          {!disableDecorators && (
            <>
              <UIBox
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: '50%',
                  left: 0,
                  bottom: 0,
                  backgroundImage: `url(${heroBgLeft})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '10% 30%',
                  zIndex: 0,
                }}
              />
              <UIBox
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  left: '50%',
                  bottom: 0,
                  backgroundImage: `url(${heroBgRight})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '90% 30%',
                }}
              />
            </>
          )}
        </UIFlex>
      </Stack>
    </UIContainer>
  );
};

export default TitleSection;
